module.exports = __webpack_public_path__ + "static/media/logo-hackaton-3d.c8778461.png";